/**
 * Single source of truth for the Explore chip / vibe filter.
 *
 * Every UI surface that renders the chip picker MUST import from this file
 * — DO NOT define local chip lists elsewhere. Divergence between the main
 * chip row (`VibeFilterBar`) and the "Adjust filters" drawer caused the
 * live-deploy regression where the drawer still showed the old 6-vibe row
 * after the 15-chip refactor.
 *
 * Chip ids match the backend `?chip=` values exactly
 * (see `backend/routers/discover.py`).
 *
 * `comingSoon: true` chips (Flights, Transportation) are rendered as
 * disabled + show a "coming soon" toast on tap. The backend returns an
 * empty payload for these + for retired chips (e.g. `glamping`).
 */
import {
  Sparkles, Bed, PartyPopper, MapPin, Car, Ship, Plane,
  Tent, Home, Sparkle, Caravan, Rocket, TreePine,
  Wheat, Coffee,
} from "lucide-react";

export const VIBE_META = {
  any:                    { label: "Any",                     Icon: Sparkles },
  hotels:                 { label: "Hotels",                  Icon: Bed },
  resorts:                { label: "Resorts",                 Icon: MapPin },
  all_inclusive_resorts:  { label: "All-Inclusive Resorts",   Icon: Sparkle },
  cruises:                { label: "Cruises",                 Icon: Ship },
  destinations:           { label: "Destinations",            Icon: MapPin },
  activities:             { label: "Activities",              Icon: PartyPopper },
  camping_campgrounds:    { label: "Camping/Campgrounds",     Icon: Tent },
  unique_stays:           { label: "Unique Stays",            Icon: Wheat },
  lodges_inns_bnbs:       { label: "Lodges/Inns/B&Bs",        Icon: Coffee },
  cabins:                 { label: "Cabins",                  Icon: Home },
  rv_resorts:             { label: "RV Resorts",              Icon: Caravan },
  theme_parks:            { label: "Theme Parks",             Icon: Rocket },
  national_parks:         { label: "National Parks",          Icon: TreePine },
  flights:                { label: "Flights",                 Icon: Plane,  comingSoon: true },
  transportation:         { label: "Transportation",          Icon: Car,    comingSoon: true },
};

/** Chip order for the main filter row + any secondary surfaces (drawer). */
export const VIBE_ORDER = [
  "any",
  "hotels", "resorts", "all_inclusive_resorts", "cruises",
  "destinations", "activities", "camping_campgrounds",
  "unique_stays", "lodges_inns_bnbs",
  "cabins", "rv_resorts", "theme_parks", "national_parks",
  "flights", "transportation",
];

/** Filter chips only (no `any`) — useful for secondary surfaces like the
 * "Adjust filters" drawer where the "no filter" state is expressed by an
 * empty selection instead of an explicit chip. */
export const FILTER_CHIP_IDS = VIBE_ORDER.filter((id) => id !== "any");
